const SENSITIVE_KEY = /(password|token|authorization|secret|email|identity_?number|user_?id|file_?name|(?:first|last|given|family|full)_?name|(?:^|_)(?:name|title|notes|content)(?:_|$)|url|link|location)/i;

export const redactSensitiveData = (value) => {
  if (Array.isArray(value)) return value.map(redactSensitiveData);
  if (!value || typeof value !== 'object') return value;

  return Object.entries(value).reduce((redacted, [key, entry]) => {
    redacted[key] = SENSITIVE_KEY.test(key) ? '[Filtered]' : redactSensitiveData(entry);
    return redacted;
  }, {});
};
